import React, {useState, useMemo} from "react";
import DataTable from "components/DataTable";
import { useTableData } from "../../hooks/useTableData";
import { rechargeReportsConfig } from "../../config/tableConfigs";
import PageWrapper from "components/PageWrapper";
import { ReceiptModal } from "./ReceiptPage";
import { fetchWrapper } from "utils/apiFetch";
import { useSession } from "hooks/useSession";
import { showMainToast } from "utils/showToast";

const RechargeReportsPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [loading, setloading] = useState(false);
  const {userid, role} = useSession();
  const [refreshKey, setRefreshKey] = useState(0);
  const [toast, setToast] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);
  const [statusData, setStatusData] = useState(null);
const [showStatusModal, setShowStatusModal] = useState(false);
const userRole = role === "Platform User" ? "Admin" : role;
 
  
  
   const getLast7Days = () => {
    const today = new Date();
    const last7 = new Date();
    last7.setDate(today.getDate() - 1)  ;
  
    return {
      start: last7.toISOString().split("T")[0],
      end: today.toISOString().split("T")[0],
    };
  };
  
const getTodayRange = () => {
  const now    = new Date();
  const offset = now.getTimezoneOffset(); // minutes behind UTC
  const local  = new Date(now.getTime() - offset * 60 * 1000);
  const today  = local.toISOString().split("T")[0];
  return { start: today, end: today };
};

const { start, end } = getTodayRange();
  
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  
  const [apiUrl, setApiUrl] = useState(
    `https://pro.mokshiq.in/get_recharge_report?user=${userid}&filter_date=${start}&end_date=${end}`
  );
  
 const tableData = useTableData(apiUrl, rechargeReportsConfig, refreshKey);
  const sortedData = useMemo(() => {
  if (!tableData?.data) return [];

  return [...tableData.data].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );
}, [tableData]);
  // Action handlers
  const handleView = async (report) => {
    try {
      setloading(true);
      if (!report?.id) {
        console.warn("⚠️ No ID found in selected row:", report);
        setloading(false);
        return;
      }
  
      // ✅ Use the clicked record's ID dynamically
      const url = `https://pro.mokshiq.in/show_receipt_recharge?id=${report.id}`;
      console.log("Fetching receipt for:", url);
  
      const response = await fetchWrapper(url);
  
      if (!response || !response.data) {
        console.error("No receipt data received for:", report.id);
        setloading(false);
        return;
      }
  
      setReceiptData(response.data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching receipt:", error);
    } finally {
      setloading(false);
    }
  };
  const handleStatusCheck = async (report) => {
  try {
    setStatusLoading(true);
    if (!report?.id) {
      console.warn("⚠️ No ID found in selected row:", report);
      setStatusLoading(false);
      return;
    }

    const url = `https://pro.mokshiq.in/recharge_status_check?id=${report.id}`;
    console.log("Checking status for:", url);

    const response = await fetchWrapper(url);

    if (!response || !response.data) {
      console.error("No status data received for:", report.id);
      setStatusLoading(false);
      return;
    }
    if (typeof response.data === "string") {
      showMainToast(response.data, response.status ? "success" : "danger");
      if (response.status === true) {
        setRefreshKey(prev => prev + 1);
      }
      return;
    }

    setStatusData(response.data);
  } catch (error) {
    console.error("Error checking status:", error);
  } finally {
    setStatusLoading(false);
  }
};
  

  const handleEdit = (report) => {
    console.log("Editing report:", report);
    // Navigate to edit page or open modal
    // Example: navigate(`/wallet-reports/${report.id}/edit`);
  };

  const handleDelete = (report) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      console.log("Deleting report:", report);
      // Make API call to delete
      // Then refresh data: tableData.refetch();
    }
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    // Implement export functionality
    alert(`Exporting ${selectedIds.length} selected records`);
  };
  const buildUrl = (start, end) =>
  `https://pro.mokshiq.in/get_recharge_report?user=${userid}&filter_date=${start}&end_date=${end}`;
const handleDateFilter = (startDate, endDate) => {
  const newUrl = buildUrl(startDate, endDate);
  setApiUrl(newUrl);
  setRefreshKey(prev => prev + 1); // ✅ always triggers re-fetch
};
  
  

  const handleDeleteSelected = (selectedIds) => {
    if (
      window.confirm(
        `Are you sure you want to delete ${selectedIds.length} records?`
      )
    ) {
      console.log("Deleting selected records:", selectedIds);
      // Make API call to delete multiple records
      // Then refresh data: tableData.refetch();
    }
  };
  const filteredConfig = useMemo(() => {
    const baseConfig = { ...rechargeReportsConfig };

    // Define which columns to show for each role
    const roleColumnMap = {
      Retailer: [
       "id", "txn_id","opid", "operator", "product", "number", "amount", "status",
        "Opening Balance BC", "BC Commission", "BC TDS", "Closing Balance BC",
        "created_at", "api_txn_id","r_type", "order_id"
      ],
      "API Partner": [
        "id", "txn_id","opid", "operator", "product", "number", "amount", "status",
         "Opening Balance BC", "BC Commission", "BC TDS", "Closing Balance BC",
         "created_at", "api_txn_id","r_type", "order_id","api_response"
       ],
      "Admin": [
  "id",
  "txn_id",
  "BC Name",
  "Phone",
  "operator",
  "product",
  "number",
  "amount",
  "status",
  "Opening Balance",          // ✅ Admin's own balance
  "Commission",
  "TDS",
  "Charge",
  "GST",
  "Closing Balance",          // ✅ capital B — matches JSON
  "Opening Balance BC",       // ✅ BC balance
  "BC Commission",
  "BC TDS",
  "Closing balance BC",       // ⚠️ lowercase 'b' — must match JSON exactly
  "Transection Flow",         // ✅ note: typo in API, keep as-is
  "Wallet Txn",
  "TXN ID",
  "api_response",
  "created_at",
],
     "Main Admin": [
  "id",
  "txn_id",
  "BC Name",
  "Phone",
  "operator",
  "product",
  "number",
  "amount",
  "status",
  "Opening Balance MAdmin",
  "Commission",
  "Charge",
  "TDS",
  "Closing balance MAdmin", 
  "api_response",  // ⚠️ lowercase 'b' — must match JSON exactly
  "created_at",
],
      
    "White label": [
      "id",
      "txn_id", 
      "BC Name", 
      "Phone", 
      "operator", 
      "number", 
      "amount", 
      "status",
      "Opening Balance", // Matches your JSON
      "Commission",      // Matches your JSON
      "TDS",             // Matches your JSON
      "Charge",          // Matches your JSON
      "GST",             // Matches your JSON
      "Closing Balance", // Matches your JSON
      "api_response",
      "created_at"     // Matches "created_at"
    ]
    };

    const allowed = roleColumnMap[userRole] || [];

    baseConfig.columns = rechargeReportsConfig.columns.filter(col => allowed.includes(col.key));
    return baseConfig;
  }, [userRole]);

  return (
    <div>
       {loading && (
  <div 
    className="page-loader-overlay d-flex justify-content-center align-items-center"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255,255,255,0.7)',
      zIndex: 3000,
    }}
  >
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
)}
{statusLoading && (
      <div className="page-loader-overlay d-flex justify-content-center align-items-center"
        style={{ position:'fixed', top:0, left:0, width:'100%', height:'100%',
          backgroundColor:'rgba(255,255,255,0.7)', zIndex:3000 }}>
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Checking status...</span>
        </div>
      </div>
    )}
    <PageWrapper config={rechargeReportsConfig} onDateFilter={handleDateFilter}>
      <DataTable
        config={filteredConfig}
        tableData={tableData}
        onView={handleView}
        onEdit={handleStatusCheck} 
        onDelete={handleDelete}
        onExport={handleExport}
        onDeleteSelected={handleDeleteSelected}
        onStatusCheck = {handleStatusCheck} 
        
        
      />
      
    </PageWrapper>
    <ReceiptModal
    receiptData={receiptData}
    isOpen={showModal}
    onClose={() => setShowModal(false)}
    title="Recharge Receipt"
    logoUrl={"assets/images/logo/2.png"} // You can pass your logo URL here
/>
</div>
    
  );
};

export default RechargeReportsPage;
